import axios from 'axios';
// import request from '@/common/utils/request.js';
import i18next from 'i18next';
import NamespaceManager from './namespaceManager';
import { defaultLngCode } from './constant.js';
const requestMap = {};
const cdnMapPromise = {};

export const commonNs = ['common'];

const getFixedTKey = (lng, ns) => `${lng}/${ns.join(',')}`;
let fixedTMap = {};

function getCdnUrl(lng, ns) {
    if (!cdnMapPromise[lng]) {
        cdnMapPromise[lng] = axios
            .get(`/api/international/publish/cdn/Site/${lng}`)
            .then(res => {
                return res.reduce(function (pre, cur) {
                    pre[cur.module] = cur.fileUrl;
                    return pre;
                }, {});
            });
    }
    return cdnMapPromise[lng].then(cdnMap => {
        const url = cdnMap[ns];
        if (url) {
            return url;
        }
        throw `${lng}: ${ns} lack in admin(cdn)`;
    });
}

function genArgs(args, returnEmptyWhenNotFound) {
    let ret = [...args];
    if (!returnEmptyWhenNotFound) {
        return ret;
    }
    const defaultValueOption = { defaultValue: '' };
    if (!ret[1]) {
        //no options
        ret[1] = { ...defaultValueOption };
    } else if (typeof ret[1] == 'object' && !args[1].defaultValue) {
        ret[1] = Object.assign({}, args[1], { ...defaultValueOption });
    }
    return ret;
}
let hasPrintTranslationSource = false;

function getTranJson(lng, ns) {
    //can be replaced with http request
    //or find resource in module data
    let key = `${lng}/${ns}`;
    if (requestMap[key]) {
        return requestMap[key];
    }
    let urlPs = process.env.LNG_LOCALES
        ? Promise.resolve(`/lng/locales/${lng}/${ns}.json`)
        : getCdnUrl(lng, ns);
    //使用本地数据 url
    if (!hasPrintTranslationSource) {
        console.log(
            'The internal copy of the code uses translation from ',
            process.env.LNG_LOCALES ? 'lng/locales' : 'cdn'
        );
        hasPrintTranslationSource = true;
    }

    // let urlPs = getCdnUrl(lng, ns);
    return urlPs.then(url => {
        return (requestMap[key] = axios.get(url).then(
            res => res,
            err => {
                console.error(`Translation Not Found : ${url}`, err);
                return {};
            }
        ));
    }, console.error);
}

function loadNs(lng, ns) {
    if (!lng) {
        lng = i18next.language;
    }
    let nsArray = Array.isArray(ns) ? ns : [ns];
    let ps = nsArray.map(ns => {
        if (!ns) {
            return Promise.resolve();
        }
        if (i18next.hasResourceBundle(lng, ns)) {
            return Promise.resolve(i18next.getResourceBundle(lng, ns));
        }
        return getTranJson(lng, ns).then(resources => {
            i18next.addResourceBundle(lng, ns, resources);
        });
    });
    return Promise.all(ps);
}

const globalization = (function () {
    let defaultNsManager = new NamespaceManager();
    defaultNsManager.addNamespace('global', commonNs);
    let namespaceManagers = [defaultNsManager];
    let prefix = localStorage.getItem('langPrefix') || '';
    let isInitialized = false;
    function init(lng) {
        if (isInitialized) {
            return;
        }
        isInitialized = true;
        // let localLng = localLanguage.getFromGlobalData(globalData);
        window.i18next = i18next;
        i18next.init({
            lng: lng,
            fallbackLng: defaultLngCode,
            fallbackNS: defaultNsManager.nsArray,
            initImmediate: false,
            resources: {}
        });
        let oldT = i18next.t;
        // TODO: 临时特殊前缀，只为在翻译有结果时，显示特殊前缀用来区分已翻译,后续应删除
        i18next.t = function () {
            let res = oldT.apply(this, arguments);
            return res ? prefix + res : res;
        };

        loadNs(null, defaultNsManager.nsArray);
    }

    let getAllNs = function () {
        return namespaceManagers.map(nm => nm.nsArray).flat(1);
    };

    return {
        init, //必须在全局数据准备好之后才能init
        resetPre(_prefix) {
            prefix = _prefix;
            localStorage.setItem('langPrefix', prefix);
            window.location.reload();
        },
        registerNamespaceManager(manager) {
            //manager统一规则
            /**
             * Interface NamespaceManager{
             *  nsArray: Array<string>,
             * }
             */
            namespaceManagers.push(manager);
        },
        unregisterNamespaceManager(manager) {
            let len = namespaceManagers.length;
            for (let i = 0; i < len; i++) {
                if (namespaceManagers[i] === manager) {
                    namespaceManagers.splice(i, 1);
                    break;
                }
            }
        },
        loadNs(ns) {
            return ns ? loadNs(null, ns) : Promise.resolve();
        },
        changeLanguage(lng) {
            i18next.changeLanguage(lng);
            //数据来源的多种情况，很可能是统一刷新页面location.reload()
            // return window.location.reload();
            fixedTMap = {};
            return loadNs(lng, getAllNs()).then(_ => {
                namespaceManagers.map(v => v.languageChangedCallback());
            });
        },
        $st(ns, ...args) {
            if (!Array.isArray(ns)) {
                ns = [ns];
            }
            const lng = i18next.language;
            const mapKey = getFixedTKey(lng, ns);
            const fixedT = (fixedTMap[mapKey] =
                fixedTMap[mapKey] || i18next.getFixedT(lng, ns));
            return fixedT.apply(this, genArgs(args, !prefix));
        },
        // TODO 修改方法传参数方式，使js和vue的方法使用方式一致
        t: function (key, params) {
            return i18next.t(key, params);
        },
        $t(key, ...args) {
            const nsKey = key.split(':');
            if (nsKey.length <= 1) {
                //no ns
                return i18next.t(key, ...args);
            }
            const [ns, inKey] = nsKey;
            const lng = i18next.language;
            const mapKey = getFixedTKey(lng, [ns]);
            //ns count > 1
            const fixedT = (fixedTMap[mapKey] =
                fixedTMap[mapKey] || i18next.getFixedT(lng, ns));
            return fixedT(inKey, ...genArgs(args, !prefix));
        },
        lng() {
            return i18next.language;
        }
    };
})();
window.siteGlobalization = globalization;
export default globalization;
